import { render, staticRenderFns } from "./BranchDeltaSyncDetailsTable.vue?vue&type=template&id=30513afe"
import script from "./BranchDeltaSyncDetailsTable.vue?vue&type=script&lang=js"
export * from "./BranchDeltaSyncDetailsTable.vue?vue&type=script&lang=js"
import style0 from "./BranchDeltaSyncDetailsTable.vue?vue&type=style&index=0&id=30513afe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports